module.exports = __webpack_public_path__ + "static/img/jianli-code.568e7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/jianli-code.png
// module id = fNX1
// module chunks = 0